export const formatDateForLocale = (dateString: string): string => {
    const date = new Date(dateString + 'T00:00:00');
    return new Intl.DateTimeFormat(navigator.language).format(date);
};
